import { setEntity } from '@process-advisor/process-miner/api/methods/eventlog/setEntity';

export const eventlogMethods = {
    setEntity,
};
